import fetchApi from "../fetchApi";
export const GetOrderDetail = async (id = "") => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(`card-issuing/order/${id}`, options);
};
